import { FunctionComponent } from 'react'
import { Typography } from '@mui/material'
import { accountingProviderName } from '../../../shared/constants/accounting-providers'
import { emissionSourceName } from '../../../shared/constants/emission-sources'

/**
 * Where a row came from, in one cell. An integration shows its ledger's name, for an organisation
 * with more than one connected. Anything else shows the source's name: a spreadsheet import, a
 * bill extraction, a manual entry. Used by the pending, committed and discarded tabs of the
 * Financial page and the emissions list, so a source is shown one way everywhere. Name only, no
 * logo: the ledgers' marks are drawn to different scales, so at table size one reads as tiny next
 * to another.
 */
export const SourceLabel: FunctionComponent<{
  /** The ledger's provider code for an integration row. */
  providerCode?: string | null,
  /** The recorded source for everything else (defaults to manual entry, as the backend does). */
  source?: string | null,
}> = ({ providerCode, source }) => {
  const label = providerCode ? accountingProviderName(providerCode) : emissionSourceName(source)
  return <Typography variant='body2' sx={{ whiteSpace: 'nowrap' }}>{label}</Typography>
}
